import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material';
import { environment } from 'src/environments/environment';
import { MainService } from '../_services/main.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs'; 

@Component({
  selector: 'app-add-message',
  templateUrl: './add-message.component.html',
  styleUrls: ['./add-message.component.scss']
})
export class AddMessageComponent implements OnInit {
  @ViewChild('emojiDiv') emojiDiv: ElementRef;
  parameters: any; 
  time=0;
  assetURL :String;
  messageForm : FormGroup;
  currentUser : any;
  user_id = 0;
  sub_friendList : Subscription;
  sub_postMsg : Subscription;
  friendList = []; 
  
  constructor(public dialog: MatDialog,private _appService : MainService,private formBuilder : FormBuilder) { 
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser != null) {
      this.user_id = this.currentUser.id;
    }
  }

  ngOnInit(){
    this.assetURL = `${environment.assetURL}`;
    this.messageForm  = this.formBuilder.group({
      user_id : this.user_id,
      friends : ['',Validators.required],
      temp_message : ['',Validators.required]
    });
    this.getFriendList(); 
    this.loadScript('assets/js/jquery_basic.js');
    this.loadScript('assets/js/config.js');
    this.loadScript('assets/js/util.js');
    this.loadScript('assets/js/jquery.emojiarea.js');
    this.loadScript('assets/js/emoji-picker.js');
    this.loadScript('assets/js/emo_sel.js');
  }

  loadScript(url) {
    const body = <HTMLDivElement> document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }

  getFriendList(){
    this.sub_friendList = this._appService.friendList(this.user_id).subscribe(res=>{
      if(res){
        let friendList  = Object.values(res);
        friendList.pop();
        this.friendList  =  friendList;
      }
    })
  }

  sendMessage(){
    if(this.messageForm.invalid){
      return true;
    }

    const draft_mesage = this.messageForm.get('temp_message').value;
    if(draft_mesage){
      let emojiHtml = this.emojiDiv.nativeElement.querySelector('.emoji-wysiwyg-editor').innerHTML; 
      var messageStr  = '';
      const results = emojiHtml.split(/([^<>]*?)(<\/?[-:\w]+(?:>|\s[^<>]*?>)|$)/g);
      results.forEach((element,key) => {
        if(element){
          element = element.replace("&nbsp;",'');
          const img_data  =  element.split('alt="');
          if(img_data[1]){
            const alt  =  img_data[1].split('"');
            messageStr  +=    (key === 0)?alt[0]:alt[0];
          }else{ 
            messageStr  +=    (key === 0)?element:" "+element;
          } 
        }
      }); 
      this.emojiDiv.nativeElement.querySelector('.emoji-wysiwyg-editor').innerHTML  = '';
      let data = {
        user_id : this.user_id,
        message : messageStr,
        friends : this.messageForm.get('friends').value
      }
      this.sub_postMsg = this._appService.addNewMessage(data).subscribe(shows => {
        this.sub_postMsg.unsubscribe(); 
      }, err => {
        console.log(err);
      });
      this.dialog.closeAll();
    }
  } 

}
